<template>
  <van-swipe
    class="my-swipe"
    :autoplay="3000"
    :width="width"
    :height="width"
    indicator-color="#1baeae"
    lazy-render
  >
    <van-swipe-item v-for="(item, index) in list" :key="index">
      <van-image :src="item.url">
      </van-image>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
export default {
  props: {
    list: Array,
    width: Number,
  },
};
</script>

<style lang='less' scoped>
.my-swipe {
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
